import P2Regular from 'components/typography/P2Regular';
import { RevisionRow } from 'components/tables/data/revision/types';

/**
 * A column for displaying the external ID in the revision table.
 */
export default function RemoteIdColumn({ data }: { data: RevisionRow }) {
  return <P2Regular lineClamp={3}>{data.remoteId ?? null}</P2Regular>;
}
